import React, { useState } from 'react';
import { FiBarChart2, FiSend, FiCheck } from 'react-icons/fi';
import useActivePoll from './useActivePoll';
import PollResults from '../polls/PollResults';
import styles from './ActivePollWidget.module.css';

function ActivePollWidget() {
  const {
    poll, loading, answered, myAnswerCount, maxAnswers, submitting, error, submitAnswer,
    optionTallies, ratingStats, wordCloudData, answers, voteOnIdea,
  } = useActivePoll();
  const [draft, setDraft] = useState('');
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  const [ratingValue, setRatingValue] = useState(null);

  if (loading && !poll) return null;
  if (!poll) return null;

  const type = poll.question.type || 'open_text';

  const handleFreeTextSubmit = (e) => {
    e.preventDefault();
    if (!draft.trim()) return;
    submitAnswer({ answerText: draft });
    setDraft('');
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <FiBarChart2 size={20} />
          Live Poll
          {poll.courseCode && <span className={styles.courseBadge}>{poll.courseCode}</span>}
        </h2>
      </div>

      <div className={styles.body}>
        <div className={styles.questionText}>{poll.question.text}</div>

        {error && <div className={styles.errorBanner}>{error}</div>}

        {maxAnswers > 1 && !answered && (
          <div className={styles.remainingHint}>{maxAnswers - myAnswerCount} of {maxAnswers} answers remaining</div>
        )}

        {answered ? (
          <>
            <div className={styles.answeredState}>
              <FiCheck size={18} />
              {maxAnswers === 1 ? 'Your answer was submitted.' : `You've used all ${maxAnswers} of your answers.`}
            </div>
            <div className={styles.resultsBlock}>
              <PollResults
                activeQuestion={{ ...poll.question, question_type: type }}
                optionTallies={optionTallies}
                ratingStats={ratingStats}
                wordCloudData={wordCloudData}
                answers={answers}
                onVote={voteOnIdea}
                wordCloudWidth={420}
                wordCloudHeight={260}
              />
            </div>
          </>
        ) : type === 'multiple_choice' ? (
          <div className={styles.optionList}>
            {(poll.question.options || []).map((opt) => (
              <button
                key={opt.id}
                type="button"
                className={`${styles.optionButton} ${selectedOptionId === opt.id ? styles.optionButtonActive : ''}`}
                onClick={() => setSelectedOptionId(opt.id)}
              >
                {opt.text}
              </button>
            ))}
            <button
              type="button"
              className={styles.answerSendButton}
              disabled={submitting || !selectedOptionId}
              onClick={() => submitAnswer({ optionId: selectedOptionId })}
            >
              <FiSend size={16} />
              Submit
            </button>
          </div>
        ) : type === 'rating' ? (
          <div className={styles.ratingRow}>
            {[1, 2, 3, 4, 5].map((v) => (
              <button
                key={v}
                type="button"
                className={`${styles.ratingButton} ${ratingValue === v ? styles.ratingButtonActive : ''}`}
                onClick={() => setRatingValue(v)}
              >
                {v}
              </button>
            ))}
            <button
              type="button"
              className={styles.answerSendButton}
              disabled={submitting || !ratingValue}
              onClick={() => submitAnswer({ ratingValue })}
            >
              <FiSend size={16} />
              Submit
            </button>
          </div>
        ) : (
          <form className={styles.answerForm} onSubmit={handleFreeTextSubmit}>
            <input
              type="text"
              className={styles.answerInput}
              placeholder={type === 'ideas' ? 'Share an idea...' : 'Type your answer...'}
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              maxLength={500}
            />
            <button type="submit" className={styles.answerSendButton} disabled={submitting || !draft.trim()}>
              <FiSend size={16} />
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ActivePollWidget;
